<div class="px-md py-sm flex justify-between items-center bg-white border-b-1 border-border-primary-light">
  <ng-content select="[left-container]"></ng-content>
  <core-svs-logo class="h-[24px]"/>
  <core-icon-button icon="settings" btnStyle="ghost" (triggered)="openSettings()"/>
</div>
